/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import { Span } from '@opentelemetry/api'
import type { FCPMetricWithAttribution } from 'web-vitals/attribution'

import { setNumberAttribute, setStringAttribute } from '../../utils/span-attributes'

export function setFCPAttributionAttributes(span: Span, metric: FCPMetricWithAttribution): void {
	const { attribution } = metric

	setNumberAttribute(span, 'fcp.time_to_first_byte', attribution.timeToFirstByte)
	setNumberAttribute(span, 'fcp.first_byte_to_fcp', attribution.firstByteToFCP)
	setStringAttribute(span, 'fcp.load_state', attribution.loadState)
}
